import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl, formatDate } from "@/lib/api";
import { ArticleCard } from "@/components/Cards";

export default function Articles() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/public/articles").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);
  const [lead, ...rest] = items || [];

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-14 sm:pt-20" data-testid="articles-page">
      <p className="eyebrow rise">Articles</p>
      <h1 className="rise d1 mt-4 text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1a261f]">Read before you go.</h1>
      {items === null ? (
        <p className="mt-16 text-sm text-[#5a665e]">Loading…</p>
      ) : !lead ? (
        <p className="mt-16 text-[#5a665e]" data-testid="articles-empty">No articles yet.</p>
      ) : (
        <>
          <Link to={`/articles/${lead.slug}`} className="mt-14 grid md:grid-cols-12 gap-8 items-center group img-zoom" data-testid="article-featured">
            <div className="md:col-span-7 overflow-hidden aspect-[16/10] bg-[#f4f0ea]">
              <img src={imgUrl(lead.cover_image)} alt={lead.title} className="w-full h-full object-cover" />
            </div>
            <div className="md:col-span-5">
              <p className="eyebrow">Featured · {lead.category} · {formatDate(lead.created_at)}</p>
              <h2 className="mt-3 text-3xl sm:text-4xl leading-tight text-[#1a261f] group-hover:text-[#1f402b]">{lead.title}</h2>
              <p className="mt-4 text-[#5a665e] leading-relaxed">{lead.excerpt}</p>
            </div>
          </Link>
          <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-10 border-t border-[#e2dcd4] pt-14">
            {rest.map((a) => <ArticleCard key={a.id} a={a} />)}
          </div>
        </>
      )}
    </div>
  );
}
